import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

const initialState = {
  myList: [],
};

const slice = createSlice({
  name: "myList",
  initialState,
  reducers: {
    getMyListStringSuccess(state, action) {
      state.myList = action.payload.titleIds.split(",").map((i) => parseInt(i));
    },
    addItemToMyListSuccess(state, action) {
      const index = state.myList.indexOf(action.payload);
      if (index === -1) {
        state.myList.push(action.payload);
      }
    },
    deleteItemFromMyListSuccess(state, action) {
      const index = state.myList.indexOf(action.payload);
      if (index > -1) {
        state.myList.splice(index, 1);
      }
    },
  },
});

// Reducer
export default slice.reducer;

export function getMyListString() {
  return async (dispatch) => {
    try {
      const response = await axios.get("/mylist/list");
      dispatch(slice.actions.getMyListStringSuccess(response.data));
    } catch (error) {
      console.error(error);
    }
  };
}

export function addItemToMyList({ contentId, type }) {
  return async (dispatch) => {
    try {
      const response = await axios.post("/mylist", { contentId, type });
      if (response.data.status) {
        dispatch(slice.actions.addItemToMyListSuccess(contentId));
      }
    } catch (error) {
      console.error(error);
    }
  };
}

export function deleteItemFromMyList({ id, type }) {
  return async (dispatch) => {
    try {
      const response = await axios.delete(`/mylist/${id}/${type}`);
      if (response.data.status) {
        dispatch(slice.actions.deleteItemFromMyListSuccess(id));
      }
    } catch (error) {
      console.error(error);
    }
  };
}
